import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 90000,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('uh24_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // optionally redirect or clear token here
    }
    return Promise.reject(err);
  }
);

export const fileApi = {
  // GET URL for a stored file
  url: (fileId) => `${BACKEND_URL}/api/files/${fileId}/data`,
};

// AI helpers
export const aiApi = {
  ocrVehicle: (image_base64) => API.post('/ai/ocr/vehicle', { image_base64 }),
  ocrOpponent: (image_base64, doc_type) => API.post('/ai/ocr/opponent', { image_base64, doc_type }),
  voiceToReport: (payload) => API.post('/ai/voice-to-report', payload),
  analyze: (caseId) => API.post(`/ai/analyze/${caseId}`),
  report: (caseId) => API.post(`/ai/report/${caseId}`),
  adminSummary: (caseId) => API.post(`/ai/admin-summary/${caseId}`),
  docChecklist: (caseId) => API.get(`/ai/doc-checklist/${caseId}`),
  pdfUrl: (caseId) => `${BACKEND_URL}/api/ai/pdf/${caseId}`,
};

export const casesApi = {
  updateOpponent: (caseId, opponent) => API.patch(`/cases/${caseId}/opponent`, { opponent }),
  updateVehicle: (caseId, vehicle) => API.patch(`/cases/${caseId}/vehicle`, { vehicle }),
  getByPin: (caseId, pin) => API.get(`/cases/${caseId}`, { params: { pin } }),
};
